<template>
  <div>
    <load-profile></load-profile>
    <b-card>
      <validation-observer ref="createForm" #default="{ invalid }">
        <n-form-confirmation
          key="createForm"
          @submit="submit"
          :form="$refs.createForm"
          :disabled="invalid"
          confirm-button-text="button.create"
        >
          <!-- Multi-language Name Field -->
          <validation-provider
            v-slot="{ errors }"
            :name="$t('field.projectName')"
            :rules="
              locale === appLocale
                ? 'required|min:3|max:47'
                : 'min:3|max:47'
            "
            style="width: 100%;"
          >
            <b-form-group
              :label="$t('field.projectName')"
              :state="errors.length === 0 ? null : false"
              class="mb-3"
            >
              <div class="d-flex align-items-center">
                <div class="flex-grow-1 mr-1">
                  <b-form-input
                    v-model="data.translation.name[locale]"
                    :placeholder="$t('placeholder.enterProjectName')"
                    :state="errors.length === 0 ? null : false"
                  />
                </div>
                <div style="min-width: 80px">
                  <b-form-select
                    v-model="locale"
                    :options="locales"
                    class="language-select"
                  />
                </div>
              </div>
              <small class="text-danger">{{ formatErrorMessage(errors[0]) }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Remark Field (Single Language) -->
          <validation-provider
            v-slot="{ errors }"
            :name="$t('label.remark')"
          >
            <b-form-group
              style="color: #6e6b7b"
            >
              <div class="col-form-label pt-0">
                <span>{{ $t('label.remark') }}</span>
                <span class="text-muted"> - {{ $t('field.optional') }}</span>
              </div>
              <b-form-textarea
                v-model="data.remark"
                :placeholder="$t('placeholder.enterRemark')"
                rows="3"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ formatErrorMessage(errors[0]) }}</small>
            </b-form-group>
          </validation-provider>

          <b-row>
            <b-col cols="12" class="text-right">
              <n-button-loading
                type="submit"
                class="mt-1 mr-1"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="primary"
                :loading="loading"
                :disabled="invalid"
                v-if="$can('create', permissionType)"
              >
                {{ $t("button.create") }}
              </n-button-loading>
              <n-button-loading
                type="button"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="outline-secondary"
                :loading="loading"
                class="mt-1"
                @submit="back"
              >
                {{ $t("button.cancel") }}
              </n-button-loading>
            </b-col>
          </b-row>
        </n-form-confirmation>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BRow,
  BCol,
  BCard,
} from 'bootstrap-vue';
import Repository from '@/repositories/RepositoryFactory';
import Ripple from 'vue-ripple-directive';
import NButtonLoading from '@/components/NButtonLoading.vue';
import NFormConfirmation from '@/components/NFormConfirmation.vue';
import { mapValidationMessage } from '@/libs/helper';

const ProjectRepository = Repository.get('project');

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BRow,
    BCol,
    BCard,
    NButtonLoading,
    NFormConfirmation,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      data: {
        translation: {
          name: {
            en: '',
            zh: '',
            km: '',
            vi: '',
          }
        },
        remark: '',
      },
      loading: false,
      locale: this.$i18n.locale.split('-')[0],
      locales: [
        { value: 'en', text: 'English' },
        { value: 'zh', text: '中文' },
        { value: 'km', text: 'ខ្មែរ' },
        { value: 'vi', text: 'Tiếng Anh' },
      ],
    };
  },
  watch: {
    '$i18n.locale'(val) {
      const [language] = val.split('-')
      this.locale = language
    },
  },
  computed: {
    appLocale() {
      return this.$i18n.locale.split('-')[0];
    }
  },
  methods: {
    formatErrorMessage(message) {
      return message ? this.$t(message) : '';
    },
    submit() {
      this.$refs.createForm.validate().then((success) => {
        if (success) {
          this.save();
        }
      });
    },
    save() {
      this.loading = true;
      ProjectRepository.create(this.data)
        .then((response) => {
          this.$router.push({
            name: `list-${this.route}`,
          });
        })
        .catch((error) => {
          if (error.response?.status === 422) {
            const errorMessage = mapValidationMessage(
              error.response.data.validate
            );
            this.$refs.createForm.setErrors(errorMessage);
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
    back() {
      this.$router.back();
    },
  },
  setup() {
    const permissionType = "manage-project";
    const route = "project";
    return { permissionType, route };
  },
};
</script>

<style lang="scss" scoped>
.language-select {
  height: 100%;
}
</style>